<template>
  <AuthLayout :mode="mode">
    <ContactActions :mode="mode" />
  </AuthLayout>
</template>

<script>
import ContactActions from "@C/ContactActions.vue";
import AuthLayout from "@A/AuthLayout.vue";

export default {
  name: "EditContactSettings",
  components: {
    AuthLayout,
    ContactActions,
  },
  props: {
    mode: String,
  },
};
</script>
